<template>
  <div>
    <div class="flex wrap" v-if="mode===0">
      <draggable v-model="imgs" @change="changeDraggable">
          <div style="display: inline-block" v-for="(img, idx) in imgs" :key="`img-${idx}`">
            <div class="input-img-bg" v-if="img!==''">
              <div class="input-img" :style="'background-image: url('+ img + ');'">
                <div class="input-img-intext">
                  <div class="input-img-close" @click.stop.prevent="del_img(idx)">
                    <i class="material-icons">close</i>
                  </div>
                </div>

                <div v-if="img===''" class="input-img-intext" @click="openModal">
                  <i class="material-icons">add</i>
                  <div style="font-size:12px" v-if="img === ''">이미지 추가</div>
                </div>
              </div>
            </div>
          </div>
          <div style="display: inline-block" class="input-img-bg">
            <div class="input-img">
              <div class="input-img-intext" @click="openModal">
                <i class="material-icons">add</i>
                <div style="font-size:12px">이미지 추가</div>
              </div>
            </div>
          </div>
      </draggable>
    </div>
    <div v-else-if="mode===1">
      <button class="button" style="width: 75px;height: 28px !important;" @click="openModal">파일 선택</button>
    </div>
    <modal :name="`uploader-${index}`" :adaptive="true" :width="800" height="auto" class="modal-style">
      <div class="lp-modal-wrapper">
        <modal-image-uploader
          :isMultiple="true"
          @addImage="addImage"
          @addImages="addImages"
          @closeModal="$modal.hide(`uploader-${index}`)"></modal-image-uploader>
      </div>
    </modal>
  </div>
</template>

<script>
  import draggable from 'vuedraggable'
  import ModalImageUploader from "../modal/ModalImageUploader";
  import moment from "moment";
  export default {
    components: {ModalImageUploader,draggable},
    props:{
      images: {
        type: Array,
        default: function() {
          return []
        }
      },
      disabled: {
        type: Boolean,
        default: false
      },
      mode: {
        type: Number,
        default: 0
      }
    },
    data () {
      return {
        index: 0,
        imgs: [],
      }
    },
    created() {
      this.imgs = this.images;
      this.index = moment().format('SSSS');
    },
    watch: {
      images: function(n, o) {
        let arr = [];
        for(let i=0; i<this.images.length; i++) {
          arr.push(this.image(this.images[i]));
        }
        this.imgs = arr;
        // this.defaultImgs();
      }
    },
    mounted: function() {

      /*//file 타입인 경우
      if(typeof this.url === 'object') {
        this.set_img(this.img);
      }
      else {
        this.img = this.image(this.url);
      }*/
    },
    computed: {
      fileStyle(){
        return 'position: absolute; ' +
          'width: 1px; height: 1px; ' +
          'padding: 0; margin: -1px; ' +
          'overflow: hidden; ' +
          'clip:rect(0,0,0,0); border: 0';
      }
    },
    methods: {
      defaultImgs () {
        if(this.imgs.length===0) {
          this.imgs = [''];
        }
      },
      changeDraggable () {
        this.$emit('update:images', this.imgs);
      },
      addImages(imgs) {
        // this.$emit('addImages', imgs);
        this.imgs = this.imgs.concat(imgs);
        this.$emit('update:images', this.imgs);
        this.$modal.hide(`uploader-${this.index}`);
      },
      addImage(img) {
        // this.$emit('update:url', img);
        this.imgs.push(img)
        this.$emit('update:images', this.imgs);
        this.$modal.hide(`uploader-${this.index}`);
      },
      openModal() {
        this.$modal.show(`uploader-${this.index}`);
      },
      del_img(idx) {
        removeIndex(this.imgs, idx);
        this.defaultImgs();
        this.$emit('update:images', this.imgs);
      },

      // 이미지 화면에 설정
      set_img(img) {
        var reader = new FileReader();
        reader.onload = function(e) {
          this.img = e.target.result;
          this.$emit('onUpload', this.img);
          this.$emit('update:url', this.img);
          this.$emit('addImg');
        }.bind(this);
        if(img !== '')
          reader.readAsDataURL(img);
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  //@import '~assets/css/lp_main'
  $input-img-size = 80px
  .input-img-bg
    width $input-img-size
    height $input-img-size
    background-color white
    border 1px solid #dbdbdb
    border-radius 4px
    box-shadow inset 0 1px 2px rgba(10,10,10,0.1)
    position relative
    margin-right 10px
    margin-bottom 10px
    flex-shrink 0
    cursor pointer

  .input-img-intext
    text-align center
    margin auto
    width 100%
    color #797979
    position absolute
    top 0
    left 0
    padding-top 20px
    height 100%

    > .input-img-close
      display none
      padding 2px 4px
      background-color rgba(255,255,255, 0.9)
      font-size 14px
      color #555
      position absolute
      top 0
      right 0
      margin -2px
      line-height 13px

    i
      font-size 24px

  &:hover
    .input-img-intext
    > .input-img-close
      display block

  .input-img
    width $input-img-size
    height $input-img-size
    background-size cover
    background-position center
    position absolute

  input
    padding 0
    border 0
</style>
